import { CardData } from "./CardData";

export class CardDataDeckDisplay extends CardData {
  progressDisplay: string;
  nextReviewDisplay: string;
  progressColor:string;
  constructor(card: CardData) {
    super();
    this.progressDisplay = card.getProgressString();
    this.nextReviewDisplay = card.getTimeToNextReviewString()
    this.progressColor = card.getProgressColor();
  }
}
